import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-end-jorney',
  templateUrl: './end-jorney.component.html',
  styleUrls: ['./end-jorney.component.scss']
})
export class EndJorneyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
